import { classNames } from 'primereact/utils'

import { OrderProcessCompletions } from '../../features/selfservice/supplier/data'
import { OrderProcessBodyTemplate } from './OrderProcessBodyTemplate'

export const OrderProcessIsActiveBodyTemplate = (
  completion: OrderProcessCompletions,
  isActive: boolean,
  size?: number,
) => {
  if (!completion || !isActive) return null

  return (
    <div
      className={classNames({
        'opacity-40	': !isActive,
      })}
    >
      {OrderProcessBodyTemplate(completion, size)}
    </div>
  )
}
